import Route from '@ember/routing/route';
import { FEATURE_TOGGLES } from 'lumen/utils/constants/feature-toggle-constants';
import protectedRoute from 'lumen/utils/decorators/protected-route';

// @ts-expect-error: Unable to resolve signature of class decorator when called as an expression.
@protectedRoute({
  features: ['app.market.reservations'],
  featureToggles: FEATURE_TOGGLES.BI_SNAPSHOTS,
})
export default class MarketSnapshotsRoute extends Route {}
